import { render, staticRenderFns } from "./VenueOverview.vue?vue&type=template&id=8dbc4e40&"
import script from "./VenueOverview.vue?vue&type=script&lang=js&"
export * from "./VenueOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports